import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { deleteGlossary } from "../../../redux/ducks/glossary";

const DeleteGlossary = props => {
    const [show, hide, renderModal] = useModal();
    const [d_deleteGlossary, status, error, event] = useStatusThunk(deleteGlossary);

    event.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Delete Glossary</button>

            {renderModal(
                <React.Fragment>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--danger" onClick={() => { d_deleteGlossary({ glossaryID: props.glossaryID}) }}>Delete Glossary</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default DeleteGlossary;